import { Col, Row } from 'react-bootstrap';
import FrequentBestekkenByKeyChart from '@/components/charts/frequent-bestekken-by-key/frequent-bestekken-by-key';
import FrequentHoofdcodesChart from '@/components/charts/frequent-hoofdcodes/frequent-hoofdcodes';
import FrequentOvksChart from '@/components/charts/frequent-ovks/frequent-ovks';

export default function Home() {
    return (
        <div className="pt-4 pb-5">
            <Row className="g-3 mb-3">
                <Col sm={12} md={6}>
                    <FrequentOvksChart card className="h-100" />
                </Col>
                <Col sm={12} md={6}>
                    <FrequentBestekkenByKeyChart title="Bestekken per jaarversie" field="versie_jaarversie" type="pie" card className="h-100" />
                </Col>
            </Row>

            <Row className="g-3">
                <Col sm={12} md={6}>
                    <FrequentHoofdcodesChart card className="h-100" />
                </Col>
                <Col sm={12} md={6}>
                    <FrequentHoofdcodesChart reverse card className="h-100" />
                </Col>
            </Row>
        </div>
    );
}
